import { AxiosRequestConfig } from "axios";
import { requestWithAccessToken } from "./api";

const getLocations = async () => {
  if (import.meta.env.DEV) {
    const res = await import("../fixtures/location_api_response.json");
    return res;
  }
  const requestConfig: AxiosRequestConfig = {
    url: import.meta.env.REACT_APP_GET_FRANCHISE_OPPORTUNITY,
    baseURL: import.meta.env.REACT_APP_LOCATION_API_BASE_URL,
    method: "GET",
  };

  return await requestWithAccessToken(requestConfig);
};

export { getLocations };
